import { FC } from 'react';

import HotelAutoComplate, { HotelTypes } from '@domain/hotel/hotelAutoComplate';

import { Wrapper } from './styled';

type PropTypes = {
  onChange?: (data: HotelTypes) => void;
  isSubmit: boolean;
  resetIsSubmit: () => void;
};
const HotelSelection: FC<PropTypes> = ({
  onChange: pOnChange = (v) => v,
  isSubmit,
  resetIsSubmit,
}) => {
  return (
    <Wrapper>
      <HotelAutoComplate
        label='Konum veya Otel Adı'
        onChange={(v) => pOnChange(v)}
        isSubmit={isSubmit}
        resetIsSubmit={resetIsSubmit}
        data-test='hotel-autocomplete'
      />
    </Wrapper>
  );
};
export default HotelSelection;
